<template>
  <div class="box_title_area">
    <h3 class="service-title-b">
      총 <em>{{ numOfPack }}</em>개
    </h3>
    <span class="right_position_item">
      <button
        type="button"
        class="btn_default-a small"
        @click="onClick"
      >팩 만들기</button>
      <!-- <button
        type="button"
        class="btn_default-b small"
        data-layer="total-payment-layer"
        @click="onClickSelectGroupPack"
      >일괄 주문/결제</button> -->
    </span>
  </div>
</template>

<script>
// import { CONTEXT_TYPE } from '@/utils/constants';
export default {
  name: 'MypacksCommonTitle',
  props: {
    numOfPack: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    async onClick() {
      this.$emit('click-composition');
    },
    onClickDeleteSelection() {
      this.$emit('delete-selection');
    },
    onClickSelectGroupPack() {
      this.$emit('click-select-group-pack');
    }
  },
};
</script>

<style>

</style>
